import React from 'react';
import {
  FDAccordionGroup,
  FDHeadlineText,
  FDPaper, FDSimpleAccordion, FDStack,
} from '@facet-wealth/design';
import PropTypes from 'prop-types';
import MetaControl from 'Components/UI/Meta/MetaControl';
import { buildFacetDesignOverride } from 'Packages/FacetRest/FacetDesignOverride';

const metaOverrideSet = buildFacetDesignOverride();

export default function TransitionsDashboardPageFoundationSummaries({ collection }) {
  if (collection.resources().length() === 0) {
    return null;
  }

  const [foundationalSummary] = collection;

  return (
    <FDPaper appearance={'elevated'} margin={300} padding={500} flex={1}>
      <FDStack spacing={2} direction={'column'}>
        <FDHeadlineText value={'Foundational Summaries'} color={'textSecondary'} />
        <FDAccordionGroup mutualExclusion atLeastOneExpanded>
          <FDSimpleAccordion expansionID="cashFlow" title="Cash Flow">
            <MetaControl resource={foundationalSummary} attrName={'cashFlowSummary'} metaOverrideSet={metaOverrideSet} />
          </FDSimpleAccordion>
          <FDSimpleAccordion expansionID="planSummary" title="Plan Summary">
            <MetaControl resource={foundationalSummary} attrName={'planSummary'} metaOverrideSet={metaOverrideSet} />
          </FDSimpleAccordion>
        </FDAccordionGroup>
      </FDStack>
    </FDPaper>
  );
}

TransitionsDashboardPageFoundationSummaries.propTypes = {
  collection: PropTypes.object.isRequired,
};

TransitionsDashboardPageFoundationSummaries.defaultProps = {};
